import { Infinite } from "containers/Infinite";
import { List } from "containers/List";
import { One } from "containers/One";
import { FormContainer as Form } from "containers/Form";

export default { Infinite, List, One, Form };
